package com.appcreator.client.firebase.auth

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithApple
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignUpAction
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.di.Container
import com.appcreator.compose.events.LoginEvent
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth

class SignInWithApplePerformer(val action: FirebaseAuthSignInWithApple): Performer {
    @Composable
    override fun deferred(): Performer.Deferred {
        return signInWithApplePerformerDeferred(action)
    }
}

@Composable
expect fun signInWithApplePerformerDeferred(action: FirebaseAuthSignInWithApple): Performer.Deferred